export async function abortRequestAfter<T>(
    timeoutMs: number,
    run: (signal: AbortSignal) => Promise<T>,
): Promise<T> {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    try {
        return await run(controller.signal);
    } finally {
        clearTimeout(timer);
    }
}
